/**
 * custom-article.js
 * PHOTOPRI — Blog Interactive Elements
 * "The Gallery Spotlight" Edition
 *
 * アーティスト特化の有機的インタラクションを提供します。
 * 1. IntersectionObserver によるスタガー・フェードイン
 * 2. マウス座標を追従する「スポットライト」エフェクト（PCのみ）
 */

document.addEventListener('DOMContentLoaded', () => {
  /* =========================================================================
     1. スクロール時のフェードイン（IntersectionObserver）
     ========================================================================= */
  const offerCards = document.querySelectorAll('.st-premium-offer-card');

  if (offerCards.length > 0) {
    // 1.1 Shopifyのエディタ仕様により空のdiv要素が自動削除される問題の回避策
    // カード内の必須レイヤー（オーバーレイ、スポットライト、ノイズ）が欠損している場合は自動生成して挿入する
    offerCards.forEach(card => {
      const contentLayer = card.querySelector('.st-premium-offer-content');
      if (contentLayer) {
        const requiredLayers = [
          { className: 'st-premium-offer-overlay' },
          { className: 'st-premium-offer-spotlight' },
          { className: 'st-premium-offer-noise' }
        ];
        
        requiredLayers.forEach(layerDef => {
          const existing = card.querySelector(`.${layerDef.className}`);
          if (!existing) {
            const div = document.createElement('div');
            div.className = `${layerDef.className} ignore-empty`;
            div.setAttribute('aria-hidden', 'true');
            // コンテンツレイヤーの前に挿入して正しいZ-index順序を確保
            card.insertBefore(div, contentLayer);
          } else {
            // 既存要素にも ignore-empty を付与（テーマの div:empty { display:none } 対策）
            existing.classList.add('ignore-empty');
          }
        });
      }
    });

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0
    });

    offerCards.forEach(card => observer.observe(card));
  }

  /* =========================================================================
     2. スポットライト追従（Spotlight Tracking）
     PCのみ。カード内でマウスが動くと、CSS変数を更新して光が追従する。
     ========================================================================= */
  const isPointerDevice = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (isPointerDevice) {
    document.querySelectorAll('[data-spotlight]').forEach(card => {
      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        card.style.setProperty('--mouse-x', x + '%');
        card.style.setProperty('--mouse-y', y + '%');
      });

      card.addEventListener('mouseleave', () => {
        // マウスが離れたらスポットライトを中央へゆっくり戻す
        card.style.setProperty('--mouse-x', '50%');
        card.style.setProperty('--mouse-y', '50%');
      });
    });
  }
});
